import React from "react";
import ReactDOM from "react-dom";
// import { Provider } from "react-redux";
// import { createStore } from "redux";
import { createBrowserHistory } from "history";
import { Router, Route, Switch } from "react-router-dom";

import {
  builderIOInit,
  posthogInit,
  posthogStartSessionRecording,
} from "../shared/utils/analytics";

import fonts from "../shared/styles/fonts.css";
// import todoApp from "./reducers";
// import EMRApp from "./components/emrApp";
// import store from "./store";
//

import {
  ApolloClient,
  ApolloProvider,
  useQuery,
  useApolloClient,
} from "@apollo/client";
import { ApolloLink, HttpLink, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { ApolloCache, InMemoryCache } from "@apollo/client/cache";

import { isLoggedIn } from "./utils/portalCookies";

import Cookies from "js-cookie";

const httpLink = createHttpLink({
  uri: "/me/gql/graphql",
  credentials: "same-origin", // send up cookies for authentication
});

const authLink = setContext((_, { headers }) => {
  return {
    headers: {
      ...headers,
    },
  };
});

const client = new ApolloClient({
  link: authLink.concat(httpLink),
  cache: new InMemoryCache(),
});

import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";

import "./styles/material-overrides.css";

import indexRoutes from "./routes/index.js";

builderIOInit();

posthogInit();
posthogStartSessionRecording();

const hist = createBrowserHistory();

// var bugsnagClient = bugsnag({
//   apiKey: "8d5ff52ae3dc42f156c020937145dbb2",
//   // notifyReleaseStages: ["production", "staging"]
//   notifyReleaseStages: [""]
//   // otherOptions: value
// });
// bugsnagClient.use(bugsnagReact, React);
// var ErrorBoundary = bugsnagClient.getPlugin("react");

ReactDOM.render(
  <ApolloProvider client={client}>
    <Router history={hist}>
      <Switch>
        {indexRoutes.map((prop, key) => {
          return (
            <Route path={prop.path} component={prop.component} key={key} />
          );
        })}
      </Switch>
    </Router>
  </ApolloProvider>,
  document.getElementById("portal_container")
);
